import PropTypes from 'prop-types';
import RichTextBlock from './blocks/RichTextBlock';
import CardsCarouselBlock from './blocks/CardsCarouselBlock';
import WelcomeBlock from './blocks/WelcomeBlock';
import SimpleCardListBlock from './blocks/SimpleCardListBlock';
import CardBlock from './blocks/CardBlock';
import OnboardingBlock from './blocks/OnboardingBlock';
import EmbedDocumentBlock from './blocks/EmbedDocumentBlock';
import ZohoFormBlock from './blocks/ZohoFormBlock';
import {
  ContractsBlock,
  KluBlock,
  LoyaltyPointsBlock,
  RegistrationSuccessBlock,
} from './blocks/FeatureBlocks';

/**
 * Dispatcher v2: enruta cada bloque legacy `{ type, value }` al renderer
 * responsive correspondiente. Mantiene compatibilidad total con el schema
 * actual del backend (no se hace transform de value → data).
 */
const BLOCK_TYPES = {
  RICH_TEXT: 'richText',
  HTML: 'html',
  CARDS_CAROUSEL: 'CardsCarousel',
  WELCOME: 'Welcome',
  SIMPLE_CARD_LIST: 'SimpleCardList',
  CARD: 'Card',
  ONBOARDING: 'Onboarding',
  EMBED_DOCUMENT: 'EmbedDocument',
  ZOHO_FORM: 'ZohoForm',
  REGISTRATION_BASIC_SUCCESS: 'RegistrationBasicSuccess',
  REGISTRATION_COMPLETE_SUCCESS: 'RegistrationCompleteSuccess',
  KLU: 'KLU',
  CONTRACTS: 'Contracts',
  LOYALTY_POINTS: 'LoyaltyPoints',
};

const BlockRenderer = ({
  type, value, blockProps = {}, isPreview = false, renderCmsItem = null,
}) => {
  switch (type) {
    case BLOCK_TYPES.RICH_TEXT:
    case BLOCK_TYPES.HTML:
      return <RichTextBlock value={value} />;
    case BLOCK_TYPES.CARDS_CAROUSEL:
      return (
        <CardsCarouselBlock
          value={value}
          blockProps={blockProps}
          renderCmsItem={renderCmsItem}
        />
      );
    case BLOCK_TYPES.WELCOME:
      return <WelcomeBlock value={value} />;
    case BLOCK_TYPES.SIMPLE_CARD_LIST:
      return (
        <SimpleCardListBlock
          value={value}
          renderCmsItem={renderCmsItem}
        />
      );
    case BLOCK_TYPES.CARD:
      return <CardBlock value={value} />;
    case BLOCK_TYPES.ONBOARDING:
      return <OnboardingBlock value={value} blockProps={blockProps} />;
    case BLOCK_TYPES.EMBED_DOCUMENT:
      return <EmbedDocumentBlock value={value} />;
    case BLOCK_TYPES.ZOHO_FORM:
      return <ZohoFormBlock value={value} />;
    case BLOCK_TYPES.CONTRACTS:
      return <ContractsBlock />;
    case BLOCK_TYPES.KLU:
      return <KluBlock value={value} isPreview={isPreview} />;
    case BLOCK_TYPES.LOYALTY_POINTS:
      return <LoyaltyPointsBlock isPreview={isPreview} />;
    case BLOCK_TYPES.REGISTRATION_BASIC_SUCCESS:
    case BLOCK_TYPES.REGISTRATION_COMPLETE_SUCCESS:
      return <RegistrationSuccessBlock value={value} blockProps={blockProps} />;
    default:
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn(`[CmsBlocksV2] Tipo de bloque desconocido: ${type}`);
      }
      return null;
  }
};

BlockRenderer.propTypes = {
  type: PropTypes.string.isRequired,
  value: PropTypes.object,
  blockProps: PropTypes.object,
  isPreview: PropTypes.bool,
  renderCmsItem: PropTypes.func,
};

BlockRenderer.defaultProps = {
  value: {},
  blockProps: {},
  isPreview: false,
  renderCmsItem: null,
};

export default BlockRenderer;
